import React, { useEffect, useState, useContext } from "react";
import DataTable from "react-data-table-component";
import { faPlus, faSearch } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import StatusActive from "../../../components/constants/StatusActive";
import axios from "axios";
import Layout from "../../../components/common/Layout";
import Modal from "react-bootstrap/Modal";
import AlertContext from "../../../context/alert/alertContext";
import AuthContext from "../../../context/auth/authContext";
import Alerts from "../../layout/Alerts";
import checkTime from "../../../components/constants/CheckTime"
import { addAuditLog } from "../../../components/AuditLog"

const Classes = props => {
  const pagePermission =
      JSON.parse(localStorage.getItem("permission")) === null
      ? {IsCreate: false,
        IsDelete: false,
        IsUpdate: false,
        IsView: false}
      : JSON.parse(localStorage.getItem("permission")).filter(c => parseInt(c.MenuId) === 6)[0];
  
  const exportExcel = () => {
    //add Audit Log
    addAuditLog({ menu: "Classes" , event: "Export Classes", createBy: userId });

    const result = [];
    result.push(classesColumns.filter( c => columnsCheckFormData[c.selector]).map( x => x.name));

    (classesData).forEach(item => {
      let row = [];
      (Object.keys(columnsCheckFormData).filter(k => columnsCheckFormData[k])).forEach(key => {
        if(key === 'Image'){
          row.push(item['FilePath']);
        } else if(key === 'StatusActive'){
          row.push(item[key] ? 'Active' : 'InActive');
        } else {
          row.push(item[key]);
        }
      });
      result.push(row);
    });

    const cols = classesColumns.filter(c => columnsCheckFormData[c.selector]).map(x => x.name);
    const queryString = JSON.stringify(formData);

    console.log(JSON.stringify(cols));
    console.log(JSON.stringify(queryString));
    
    //console.log(result);
    axios.get(process.env.REACT_APP_API_URL + "/api/exportexcelclasses/", {
      responseType: 'blob',
      //params: {data : result}
      params: {col : `${JSON.stringify(cols)}`, formData : `${queryString}` }
     }).then(response => {
        let link = document.createElement('a');
        let day = new Date();
     
        link.href = window.URL.createObjectURL(new Blob([response.data], 
          {type:'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'}));;
        link.download = day.toISOString().slice(0,10) + "-Classes_export.xlsx";
        link.click();
     }).catch(error => {
        console.log(error)
     })
  }
  const authContext = useContext(AuthContext);
  const alertContext = useContext(AlertContext);
  const { setAlert } = alertContext;
  const [classesData, setClassesData] = useState([]);
  const [showEditModal, setShowEditModal] = useState({
    show: "",
    showPop: false,
    classesId: ""
  });
  const [showDeleteClass, setShowDeleteClass] = useState({
    classId: "",
    showPop: false
  });
  const [showConfirmClass, setShowConfirmClass] = useState(false);
  const userId =
    localStorage.getItem("user") === null
      ? null
      : JSON.parse(localStorage.getItem("user"))[0].Id;
  const [formData, setFormData] = useState({
    classesCode: "",
    classesText: ""
  });
  const [classesFormData, setClassesFormData] = useState({
    classesCode: "",
    classesTextEN: "",
    classesTextTH: "",
    createBy: userId
  });
  const { classesCode, classesTextEN, classesTextTH } = classesFormData;
  const ClassesOnChange = e =>
    setClassesFormData({ ...classesFormData, [e.target.name]: e.target.value });
  const classesColumns = [
    {
      cell: row => (
        <div>
          <button
            hidden={!pagePermission.IsUpdate}
            className="btn btn-sm btn-primary ml-2"
            type="button"
            onClick={() => {
              setShowEditModal({
                show: "Edit",
                showPop: true,
                classesId: row.ClassesId
              });
            }}
          >
            <i className="fa fa-pencil"></i> Edit
          </button>
          <button
            hidden={!pagePermission.IsDelete}
            className="btn btn-sm btn-danger ml-2"
            type="button"
            onClick={() => {
              setShowDeleteClass({ classId: row.ClassesId, showPop: true });
            }}
          >
            <i className="fa fa-remove"></i> Delete
          </button>
        </div>
      ),
      ignoreRowClick: false,
      allowOverflow: true,
      width: "180px",
      button: true,
      show: pagePermission.IsUpdate|| pagePermission.IsDelete ? 1:0
    },
    {
      name: "Classes",
      selector: "ClassesCode",
      sortable: true,
      wrap: true
    },
    {
      name: "Text Th",
      selector: "ClassesTextTH",
      sortable: true,
      //width: "350px",
      wrap: true
    },
    {
      name: "Text En",
      selector: "ClassesTextEN",
      sortable: true,
      width: "350px",
      wrap: true
    },
    {
      name: "Status",
      selector: "StatusActive",
      width: "100px",
      sortable: true,
      cell: row => (
        <div>
          {StatusActive.InActive === row.StatusActive && (
            <h6>
              <span className="badge badge-danger text-left">InActive</span>
            </h6>
          )}
          {StatusActive.Active === row.StatusActive && (
            <h6>
              <span className="badge badge-success text-left">Active</span>
            </h6>
          )}
        </div>
      )
    },
    {
      name: "LastUpdateBy",
      selector: "LastUpdateBy",
      sortable: true,
      //width: "200px",
      wrap: true
    },
    {
      name: "LastUpdateDateTime",
      selector: "LastUpdateDateTime",
      sortable: true,
      wrap: true
    },
    {
      name: "CreateBy",
      selector: "CreateBy",
      sortable: true,
      wrap: true
    },
    {
      name: "CreateDateTime",
      selector: "CreateDateTime",
      sortable: true,
      wrap: true
    }
  ];
  const [showManageColumns, setShowManageColumns] = useState(false);
  const [listColumnsShow, setListColumnsShow] = useState([]);
  const [columnsCheckFormData, setcolumnsCheckFormdata] = useState({
    ClassesCode: 1,
    ClassesTextTH: 1,
    ClassesTextEN: 1,
    StatusActive: 1,
    LastUpdateBy: 1,
    LastUpdateDateTime: 1,
    CreateBy: 0,
    CreateDateTime: 0
  });
  const reloadClasses = async () => {
    await axios
      .get(process.env.REACT_APP_API_URL + "/api/classes")
      .then(res => {
        setClassesData(res.data);
      });
    setFormData({
      classesCode: "",
      classesText: ""
    });
  };
  const AddEdit_update = () => {
    if (showEditModal.classesId === "") {
      setClassesFormData({
        classesCode: "",
        classesTextEN: "",
        classesTextTH: "",
        createBy: userId
      });
    } else {
      axios
        .get(
          process.env.REACT_APP_API_URL +
            "/api/classes/" +
            showEditModal.classesId
        )
        .then(res => {
          setClassesFormData({
            classesCode: res.data[0].ClassesCode,
            classesTextEN: res.data[0].ClassesTextEN,
            classesTextTH: res.data[0].ClassesTextTH,
            createBy: userId
          });
        });
    }
  };
  useEffect(() => {
    checkTime();
    document.addEventListener("mousedown",  (e) => { checkTime() });
    authContext.checkAuth();
    reloadClasses();
    //eslint-disable-next-line
  }, []);
  useEffect(() => {
    AddEdit_update();
    //eslint-disable-next-line
  }, [showEditModal]);
  useEffect(() => {
    setListColumnsShow(Object.keys(columnsCheckFormData).reduce((ret, curr) => 
    columnsCheckFormData[curr] ? [...ret, curr] : ret
    , []));
  },[columnsCheckFormData])

  const saveAdd = () => {
    if (showEditModal.show === "Add") {
      axios
        .post(process.env.REACT_APP_API_URL + "/api/classes", classesFormData)
        .then(res => {
          submitSave(res);
        });
    } else {
      axios
        .put(
          process.env.REACT_APP_API_URL +
            "/api/classes/" +
            showEditModal.classesId,
          classesFormData
        )
        .then(res => {
          submitSave(res);
        });
    }
    const submitSave = res => {
      if (res.data.status === "0") {
        setShowEditModal({ show: "", showPop: false, classesId: "" });
        setShowConfirmClass(false);
        setAlert(res.data.msg, "success");
        reloadClasses();
      } else {
        setAlert(res.data.msg, "danger");
        setShowConfirmClass(false);
      }
    };
  };
  const onChangeCheckColumns = (e) => {
    setcolumnsCheckFormdata({ 
      ...columnsCheckFormData, [e.target.name] : !columnsCheckFormData[e.target.name]
    })
  }
  const checkInputManageColumn = (name) => 
    (<div key={name} className="col-sm-12">
        <input 
          type="checkbox" 
          className="checkboxCustom1"
          name={name} 
          id={name}
          defaultChecked={columnsCheckFormData[name]} 
          onChange={onChangeCheckColumns} /> 
          <label htmlFor={name}>
            {classesColumns.filter( c => c.selector === name)[0].name}
          </label>
      </div>)

  return (
    <Layout activeLinkTo="/classes" menuId="6">
      <div className="container-fluid" style={{ minHeight: 500 }}>
        <Alerts />
        <div className="card border-secondary">
          <h5 className="card-header text-white bg-primary">Classes</h5>
          <div className="card-body">
            <div className="row">
              <div className="col-md-4">
                <label className="title control-label">Classes Code</label>
                <input
                  type="search"
                  className="form-control"
                  value={formData.classesCode}
                  onChange={e =>
                    setFormData({ ...formData, classesCode: e.target.value })
                  }
                />
              </div>
              <div className="col-md-8">
                <label className="title control-label">Classes Text</label>
                <input
                  type="search"
                  className="form-control"
                  value={formData.classesText}
                  onChange={e =>
                    setFormData({ ...formData, classesText: e.target.value })
                  }
                />
              </div>
            </div>

            <div className="row mt-2 float-right">
              <div className="col">
                &nbsp;&nbsp;
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={() => {
                    axios
                      .get(process.env.REACT_APP_API_URL + "/api/classes", {
                        params: formData
                      })
                      .then(res => {
                        setClassesData(res.data);
                      });
                  }}
                >
                  <FontAwesomeIcon icon={faSearch} /> Search
                </button>
              </div>
            </div>
          </div>
        </div>
        <p>&nbsp;</p>

        <div className="card border-secondary">
          <h5 className="card-header text-white bg-primary">Data</h5>
          <div className="card-body">
            <div className="table-responsive" style={{padding:"10px 0"}}>
              <button
                hidden={!pagePermission.IsCreate}
                type="button"
                className="btn btn-success"
                onClick={() => {
                  setShowEditModal({ show: "Add", showPop: true, classesId: "" });
                }}
              >
                <FontAwesomeIcon icon={faPlus} /> Add
              </button>
              <button type="button" className="btn btn-primary ml-2" onClick={() => {setShowManageColumns(true)}}>
                <i className="fa fa-cog"></i> Manage Columns
              </button>
              <button type="button" className="btn btn-primary mr-2" 
                style={{position:"absolute", right:0}} 
                onClick={() => exportExcel()} >
                <i className="fa fa-external-link"></i> Export file
              </button>
              <a href="#down" id="top" style={{position:"absolute", right:"0px", padding:"63px 17px 0 0", zIndex:"1"}}>
                <i className="fa fa-arrow-down" style={{color:"#c8c8c8"}}/>
              </a>
              <DataTable
                noHeader={true}
                pagination={true}
                paginationPerPage={50}
                paginationRowsPerPageOptions={[20, 50, 100]}
                columns={classesColumns.filter(columns => listColumnsShow.includes(columns.selector)||columns.show === 1 )}
                data={classesData}
              />
              <a href="#top" id="down" style={{position:"absolute", right:"0px", padding:"0 17px"}}>
                <i className="fa fa-arrow-up" style={{color:"#c8c8c8"}}/>
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Modal Add/Edit Classes */}
      <Modal
        show={showEditModal.showPop}
        onHide={() => {
          setShowEditModal({ show: "", showPop: false, classesId: "" });
        }}
        centered
        dialogClassName="modal-w"
      >
        <Modal.Header closeButton>
          {showEditModal.show === "Add" && (
            <Modal.Title>Add Classes</Modal.Title>
          )}
          {showEditModal.show === "Edit" && (
            <Modal.Title>Edit Classes</Modal.Title>
          )}
        </Modal.Header>
        <Modal.Body>
          <div className="form-group col labelPadRight">
            <Alerts />
            <div className="form-group row col">
              <label className="col-md-3 col-form-label form-control-sm sbold">
                Classes Code<span style={{ color: "red" }}> * </span>:
              </label>
              <div className="col-md-9">
                <input
                  type="text"
                  className="form-control  form-control-sm"
                  name="classesCode"
                  value={classesCode}
                  onChange={ClassesOnChange}
                />
              </div>
            </div>
            <div className="form-group row col">
              <label className="col-md-3 col-form-label form-control-sm sbold">
                Text TH:
              </label>
              <div className="col-md-9">
                <textarea
                  className="form-control  form-control-sm"
                  name="classesTextTH"
                  value={classesTextTH}
                  onChange={ClassesOnChange}
                ></textarea>
              </div>
            </div>
            <div className="form-group row col">
              <label className="col-md-3 col-form-label form-control-sm sbold">
                Text En:
              </label>
              <div className="col-md-9">
                <textarea
                  className="form-control  form-control-sm"
                  name="classesTextEN"
                  value={classesTextEN}
                  onChange={ClassesOnChange}
                ></textarea>
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button
            className="btn btn-danger ml-2"
            onClick={() => {
              setShowEditModal({ show: "", showPop: false, classesId: "" });
            }}
          >
            <i className="fa fa-reply"> Cancel </i>
          </button>
          <button
            className="btn btn-success ml-2"
            onClick={() => {
              if (classesCode === "") {
                setAlert("Classes Code is null! Plese fill", "warning");
              } else {
                setShowConfirmClass(true);
              }
            }}
          >
            {showEditModal.show === "Add" && (
              <i className="fa fa-plus"> Add </i>
            )}
            {showEditModal.show === "Edit" && (
              <i className="fa fa-floppy-o"> Save</i>
            )}
          </button>
        </Modal.Footer>
      </Modal>
      {/* Modal Add/Edit Classes*/}

      {/* Madal confirm Add/Edit Classes */}
      <Modal
        show={showConfirmClass}
        onHide={() => {
          setShowConfirmClass(false);
        }}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Are you sure?</Modal.Title>
        </Modal.Header>
        <Modal.Footer>
          <button
            className="btn btn-danger ml-2"
            onClick={() => {
              setShowConfirmClass(false);
            }}
          >
            <i className="fa fa-reply"></i> Cancel{" "}
          </button>
          <button
            className="btn btn-success ml-2"
            type="button"
            onClick={saveAdd}
          >
            <i className="fa fa-floppy-o"></i> Save
          </button>
        </Modal.Footer>
      </Modal>
      {/* Madal confirm Add/Edit Classes */}

      {/* Modal Delete address */}
      <Modal
        show={showDeleteClass.showPop}
        onHide={() => {
          setShowDeleteClass({ classId: "", showPop: false });
        }}
        centered
      >
        <Modal.Header closeButton>
          <div
            style={{
              width: 39,
              height: 39,
              borderWidth: 4,
              borderStyle: "solid",
              borderColor: "red",
              borderRadius: "50%",
              position: "relative"
            }}
          >
            <span
              style={{
                width: 24,
                height: 5,
                position: "absolute",
                backgroundColor: "red",
                top: 13,
                left: 3,
                transform: "rotate(45deg)"
              }}
            ></span>
            <span
              style={{
                width: 24,
                height: 5,
                position: "absolute",
                backgroundColor: "red",
                top: 13,
                left: 3,
                transform: "rotate(-45deg)"
              }}
            ></span>
          </div>
          <Modal.Title style={{ paddingLeft: 13 }}>Delete Classes</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>Please make sure Once deleted, items cannot be returned.</p>
        </Modal.Body>
        <Modal.Footer>
          <button
            className="btn btn-secondary ml-2"
            onClick={() => {
              setShowDeleteClass({ classId: "", showPop: false });
            }}
          >
            <i className="fa fa-reply"></i> Cancel{" "}
          </button>
          <button
            className="btn btn-danger ml-2"
            type="button"
            onClick={async () => {
              await axios
                .put(
                  process.env.REACT_APP_API_URL +
                    "/api/classes/delete/" +
                    showDeleteClass.classId,
                  {
                    createBy: userId
                  }
                )
                .then(res => {
                  setShowDeleteClass({ classId: "", showPop: false });
                  setAlert(res.data.msg, "danger");
                  reloadClasses();
                });
            }}
          >
            <i className="fa fa-trash-o"></i> Continue
          </button>
        </Modal.Footer>
      </Modal>
      {/* Modal Delete address*/}

      {/* Modal Manage Columns*/}
      <Modal
        size="sm"
        dialogClassName="columnsManageCustom"
        show={showManageColumns}
        onHide={() => {
          setShowManageColumns(false);
        }}
        centered
      >
        <Modal.Header closeButton className="replaceCloseBtn">
          <Modal.Title><i className="fa fa-columns" /> Manage Columns</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="container">
            <div className="row">
              {Object.keys(columnsCheckFormData).map( (e) => checkInputManageColumn(e))}
            </div>
          </div>
        </Modal.Body>
      </Modal>
      {/* Modal Manage columns*/}
    </Layout>
  );
};

export default Classes;
